<template>
  <div class="full-memory-card-container"
    :style="{
      backgroundColor: isMob ? memoryCardBackgroundColor : '#86cac6',
    }"
  >
    <div class="cancel-wrapper">
      <VoiceButton v-if="memory.speach && memory.speach !== 'pass'" :speachSrc="memory.speach"></VoiceButton>
      <div class="cancel-cross" @click="showFullMemoryCard()">&#10005;</div>
    </div>
    <div
      :class="{
        'full-memory-card-wrapper': true,
        'fade-out': fadeOutFlag,
        'disabled-scroll-bar': disabledScrollBarFlag,
      }"
      :style="{
        backgroundColor: memoryCardBackgroundColor,
      }"
    >
      <div
        :class="{
          'profile-wrapper': true,
          'fly-in-1': true,
        }"
      >
        <div class="profile-picture">
          <img src="images/papercrane.svg" height="50" width="50"/>
        </div>
        <div class="profile-name-wrapper">
          <div class="profile-job">{{memory.job}}</div>
          <div class="profile-name">{{memory.name}}</div>
        </div>
        <!-- <VoiceButton
          v-if="!isMob && memory.speach && memory.speach !== 'pass'"
          :speachSrc="memory.speach"
        />   -->
      </div>
      <div
        :class="{
          'text-wrapper': true,
          'fly-in-2': true,
        }"
      >
        {{memory.body}}
      </div>
    </div>
  </div>
</template>

<script>
import VoiceButton from './VoiceButton.vue';

export default {
  name: 'FullMemoryCard',
  components: {
    VoiceButton,
  },
  props: {
    memory: {
      type: Object,
    },
  },
  data() {
    return {
      fadeOutFlag: false,
      disabledScrollBarFlag: true,
      cardColorSet: {
        1: '#ffffff',
        2: '#d5efed',
        3: '#fffef2',
      },
    };
  },
  computed: {
    isMob() {
      return window.innerWidth < 1024 ? true : false;
    },
    memoryCardBackgroundColor() {
      return this.cardColorSet[this.memory.color];
    },
  },
  methods: {
    showFullMemoryCard() {
      this.fadeOutFlag = !this.fadeOutFlag;
      // call root function
      setTimeout(()=>{
        // call function of second layer of root
        this.$root.$children[0].$children[1].showFullMemoryCard();
      }, 333);
    },
  },
  created() {
    setTimeout(()=>{
      // call function of second layer of root
      this.disabledScrollBarFlag = false;
    }, 1500);
  },
};
</script>

<style lang="scss" scoped>
  .full-memory-card-container {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
    @media only screen and (min-width: 1024px) {
      padding: 4% 0 5% 0;
    }
    .cancel-wrapper {
      position: absolute;
      z-index: 100;
      top: 0;
      right: 0;
      width: 100%;
      margin: auto;
      display: flex;
      justify-content: flex-end;
      // align-items: flex-end;
      @media only screen and (min-width: 1024px) {
        position: relative;
        width: 550px;
        background-color: #86cac6;
      }
      .cancel-cross {
        position: relative;
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 3%;
        color: #57b09f;
        font-size: 32px;
        cursor: pointer;
        @media only screen and (min-width: 1024px) {
          justify-content: flex-end;
          align-items: flex-end;
          padding: 0;
          color: #ffffff;
        }
      }
    }
    .full-memory-card-wrapper {
      width: 100%;
      height: 100%;
      margin: auto;
      overflow-y: auto;
      background-color: #ffffff;
      padding: 70px 20px 70px 20px;
      animation-name: zoomIn;
      animation-duration: .666s;
      opacity: 1;
      @media only screen and (min-width: 1024px) {
        width: 550px;
        padding: 50px;
      }
      .profile-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        opacity: 1;
        .profile-picture {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .profile-name-wrapper {
          text-align: left;
          font-size: 1.25rem;
          .profile-name {
            line-height: 1.5;
          }
          .profile-job {
            // font-size: 12px;
            line-height: 1.5;
            color: #6f6f6f;
          }
        }
      }
      .text-wrapper {
        position: relative;
        width: 100%;
        text-align: justify;
        opacity: 1;
        white-space: pre-line;
        font-size: 1.25rem;
      }
    }
    .disabled-scroll-bar {
      overflow-y: hidden;
    }
  }

  .fade-out {
    transition: .333s ease-in-out;
    transform: scale(0);
    opacity: 0;
  }
  
  @keyframes zoomIn {
    from {
      opacity: 0;
      transform: scale(0.3);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }    
</style>

